import { FIELDS } from './constants';

export const getIdentityFields = additionalFields => [...FIELDS, ...(additionalFields || [])];
